export default {
  state: {
    cart: {
      items: []
    }
  },
  actions: {
    addToCart ({ commit }, payload) {
      commit('addToCart', {
        orderNr: payload.orderNr,
        description: payload.description,
        amount: payload.amount,
        msnr: payload.msnr
      })
    },
    removeFromCart ({ commit }, payload) {
      commit('removeFromCart', payload)
    }
  },
  mutations: {
    addToCart (state, payload) {
      state.cart.items.push(payload)
    },
    removeFromCart (state, payload) {
      let index = state.cart.items.indexOf(payload)
      state.cart.items.splice(index, 1)
    },
    logoutCart (state) {
      state.items = []
    }
  },
  getters: {
    getPaymentCart (state) {
      const items = state.cart.items
      let total = 0
      let quantity = 0
      for (let item in items) {
        total += item.amount
      }
      quantity = items.length

      return {
        items: items,
        total: total,
        quantity: quantity
      }
    }
  }
}
